import i18n from '../i18n';

const authApiMessageMap: Record<string, string> = {
  'Invalid email or password': 'auth.invalidCredentials',
  'Invalid username or password': 'auth.invalidUsernamePassword',
  'Email already registered': 'auth.emailTaken',
  'Email or mobile already registered': 'auth.contactTaken',
  'Username already taken': 'auth.usernameTaken',
  'Please enter a valid email': 'auth.invalidEmail',
  'Please enter a valid email or mobile number': 'auth.invalidContact',
  'Verification code sent to your email': 'auth.accountCreatedEmail',
  'Verification code sent to your WhatsApp': 'auth.accountCreatedWhatsapp',
  'Password must be at least 6 characters long': 'auth.passwordTooShort',
  'CAPTCHA verification required': 'auth.captchaRequired',
  'Invalid CAPTCHA': 'auth.invalidCaptcha',
  'Please verify your email before logging in.': 'auth.verifyEmailBeforeLogin',
  'Email already verified': 'auth.emailAlreadyVerified',
  'Invalid verification code': 'auth.invalidVerificationCode',
  'Verification code has expired': 'auth.verificationCodeExpired',
  'User not found': 'auth.userNotFound',
  'Server error during email verification': 'auth.verificationServerError',
  'Server error during registration': 'auth.registrationServerError',
  'Server error during login': 'auth.loginServerError',
  'Organization login failed': 'auth.orgLoginFailed',
  'If an account with that email exists, a password reset link has been sent.': 'auth.resetRequestSent',
  'Server error during password reset request': 'auth.resetRequestServerError',
  'Invalid or expired reset token': 'auth.invalidResetToken',
  'Password has been reset successfully': 'auth.resetPasswordSuccess',
  'Server error during password reset': 'auth.resetPasswordServerError',
  'Failed to send account credentials': 'auth.credentialsDeliveryFailed',
  'Congratulations! Account created. Password has been sent to your email. Please use this account to log in.': 'auth.accountCreatedEmail',
  'Congratulations! Account created. Password has been sent to your WhatsApp. Please use this account to log in.': 'auth.accountCreatedWhatsapp',
  'Multiple organization accounts found. Please select organization.': 'auth.multipleOrgAccountsFound',
  'اکانت شما توسط ادمین غیر فعال شده است. لطفا با ادمین تماس بگیرید.': 'auth.accountBlocked'
};

export function extractApiMessage(error: any): string | null {
  const data = error?.response?.data;
  if (data?.message && typeof data.message === 'string') return data.message;
  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    const firstMsg = data.errors.find((e: any) => typeof e?.msg === 'string')?.msg;
    if (firstMsg) return firstMsg;
  }
  return null;
}

export function translateAuthApiMessage(rawMessage: string | null, fallbackKey: string): string {
  if (rawMessage) {
    const mappedKey = authApiMessageMap[rawMessage];
    if (mappedKey && i18n.exists(mappedKey)) {
      return i18n.t(mappedKey);
    }
    return rawMessage;
  }
  return i18n.t(fallbackKey);
}

export function getTranslatedAuthApiError(error: any, fallbackKey: string): string {
  return translateAuthApiMessage(extractApiMessage(error), fallbackKey);
}
